import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";

import ImageUpload from "components/shared/ImageUpload";
import { Input, Textarea } from "components/shared/FormComponents";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import SlidersArray from "./SliderArray";
import { handleImage } from "helpers/functions";

const Services = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);
  // const [selectedImage, setSelectedImage] = useState({
  //   preview: null,
  //   path: "",
  // });
  const [selectedBackgroundImage, setSelectedBackgroundImage] = useState({
    preview: null,
    path: "",
  });
  const [sliders, setSliders] = useState([]);

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "home",
        slug: "services",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset(section);

    // setSelectedImage({
    //   preview: null,
    //   path: section?.image,
    // });

    setSelectedBackgroundImage({
      preview: null,
      path: section?.backgroundImage,
    });
    setSliders(section?.sliders);
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    // if (!selectedImage?.path || !selectedBackgroundImage?.path) {
    //   toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
    //   return;
    // }
    // // data.image = `/uploads/${selectedImage?.path?.split("/").at(-1)}`;
    // data.image = `/uploads/${selectedImage?.path?.split("/").pop()}`;
    // data.backgroundImage = `/uploads/${selectedBackgroundImage?.path
    //   ?.split("/")
    //   .pop()}`;
    data.sliders = sliders?.map((item) => ({
      ...item,
      image: `/uploads/${item?.image?.split("/").pop()}`,
    }));
    dispatch(
      editSection({ slug: "services", page: "home", data: { section: data } })
    );
  };

  if (loading) return <Loader />;
  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"services"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col md={12}>
                <Row>
                  <Col lg={12}>
                    <SlidersArray sliders={sliders} setSliders={setSliders}  register={register}/>
                  </Col>
                </Row>

                {/* backgroundImage  */}
                {/* <Col lg={12} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"backgroundImage"} />
                    </h5>
                    <ImageUpload
                      selectedImage={selectedBackgroundImage}
                      setSelectedImage={setSelectedBackgroundImage}
                    />
                  </div>
                </Col> */}

                <SaveChangesButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
